import io from 'socket.io-client';

let socket;
const headers = {};

function connect(uri) {
  socket = io.connect(uri);
  return socket;
}

function setHeader(name, value) {
  headers[name] = value;
}

function fetch(route, params, res, ack) {
  const channel = `${route}/channel/${Date.now()}`;
  const req = { channel, headers, params };
  if (res) {
    socket.on(channel, res);
  }
  return socket.emit(route, req, (...args) => {
    if (res) {
      socket.off(channel);
    }
    if (ack) {
      ack(...args);
    }
  });
}

export default {
  connect,
  setHeader,
  fetch,
};



// WEBPACK FOOTER //
// ./src/socket-client.js